function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { QuoteElement } from "../../lib/quote-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { property, customElement } from "lit/decorators.js";
import "../../common/legal-disclaimer.js";
import "../../common/peril-list.js";
import "../../common/promotional-description.js";
import "../../common/promotional-header.js";
import "../../common/offer-checkbox-button.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var ShippingInsurance = /*#__PURE__*/function (_QuoteElement) {
  _inherits(ShippingInsurance, _QuoteElement);

  var _super = _createSuper(ShippingInsurance);

  function ShippingInsurance() {
    var _this;

    _classCallCheck(this, ShippingInsurance);

    _this = _super.call(this, "shipping");
    _this.selectedState = SelectedState.DECLINED;
    return _this;
  }

  _createClass(ShippingInsurance, [{
    key: "toggleOfferSelection",
    value: function toggleOfferSelection() {
      if (this.selectedState === SelectedState.ACCEPTED) {
        this.decline();
      } else {
        this.accept();
      }
    }
  }, {
    key: "courierId",
    get: function get() {
      switch (this.courier) {
        case "usps":
          return 1;

        case "fedex":
          return 2;

        case "ups":
          return 3;

        default:
          return 1;
      }
    }
    /**
     * @ignore
     */

  }, {
    key: "policyAttributes",
    get: function get() {
      return {
        declared_value: this.declaredValue,
        courier_id: this.courierId,
        tracking_number: this.trackingNumber,
        shipment_date: this.shipmentDate
      };
    }
  }]);

  return ShippingInsurance;
}(QuoteElement);

ShippingInsurance.styles = [QuoteElement.styles];

__decorateClass([property({
  type: Number,
  attribute: "declared-value"
})], ShippingInsurance.prototype, "declaredValue", 2);

__decorateClass([property({
  attribute: "shipment-date"
})], ShippingInsurance.prototype, "shipmentDate", 2);

__decorateClass([property({
  attribute: "tracking-number"
})], ShippingInsurance.prototype, "trackingNumber", 2);

__decorateClass([property({
  attribute: "courier"
})], ShippingInsurance.prototype, "courier", 2);

ShippingInsurance = __decorateClass([customElement("shipping-insurance")], ShippingInsurance);
export { ShippingInsurance };